import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StoreCover = _resolveComponent("StoreCover")!
  const _component_ProductModal = _resolveComponent("ProductModal")!
  const _component_CategoriesShow = _resolveComponent("CategoriesShow")!

  return (!$setup.selectedCategory)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["home web-page sf-scope enter-content-animation", `sf-home sf-home--${$setup.storefront.template}`])
      }, [
        ($setup.storefront.settings.headerStyle === 'cover')
          ? (_openBlock(), _createBlock(_component_StoreCover, { key: 0 }))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.enabledSections, (section) => {
          return (_openBlock(), _createBlock(_resolveDynamicComponent($setup.sectionComponents[section.type]), {
            key: section.id,
            section: section,
            onOpenProduct: $setup.setModalProduct
          }, null, 40, ["section", "onOpenProduct"]))
        }), 128)),
        _createVNode(_component_ProductModal, {
          setSelectedProduct: (value) => $setup.selectedProduct = value,
          setSelectedProductVariations: (value) => $setup.selectedProduct.variations = value,
          isOpen: $setup.isProductModalOpen,
          toggleModal: $setup.toggleProductModal,
          selectedProduct: $setup.selectedProduct
        }, null, 8, ["setSelectedProduct", "setSelectedProductVariations", "isOpen", "toggleModal", "selectedProduct"])
      ], 2))
    : (_openBlock(), _createBlock(_component_CategoriesShow, {
        key: 1,
        id: $setup.selectedCategory.id,
        category: $setup.selectedCategory,
        setCategory: (value) => $setup.selectedCategory = value
      }, null, 8, ["id", "category", "setCategory"]))
}